import { useFormContext } from 'core/form/FormContext';
import { UdeFormProps } from './form.types';

export function useUdeForm(): UdeFormProps['form'] {
  const form = useFormContext();

  if (!form) {
    throw new Error('useUdeForm must be used within a form');
  }

  return form as unknown as UdeFormProps['form'];
}
